












































import {mapActions, mapState} from "vuex";
import getActivityColor from "./get-activity-color";
import SimpleTable from "../../../components/tables/SimpleTable.vue";
import moment from "moment";
import getActivityIcon from "./get-activity-icon";

export default {
  name: 'NotificationList',
  components: {SimpleTable},
  data() {
    return {
      previousLastUpdateCheck: null,
      headers: [
        {
          text: 'Tipo de actividad',
          value: 'type',
          renderInline: true,
          align: 'center'
        },
        {
          text: 'Descripcion',
          value: 'description'
        },
        {
          text: 'Usuario que realizo el cambio',
          value: 'user.fullname'
        },
        {
          text: 'Fecha',
          value: 'updatedAt',
          formatter: (value) => {
            return moment(value).fromNow()
          }
        },
        {
          text: 'Link',
          value: 'entityName',
          renderInline: true,
          align: 'center'
        },
      ]
    }
  },
  created() {
    this.previousLastUpdateCheck = this.lastActivityUpdateCheck
    const mostRecentActivity = this.activities.length > 0 ? this.activities[0] : null
    if (mostRecentActivity) {
      this.setLastActivityUpdateCheck(mostRecentActivity.updatedAt)
    }
  },
  beforeDestroy() {
    const mostRecentActivity = this.activities.length > 0 ? this.activities[0] : null
    if (mostRecentActivity) {
      this.setLastActivityUpdateCheck(mostRecentActivity.updatedAt)
    }
  },
  computed: {
    ...mapState('activities', ['activities', 'lastActivityUpdateCheck']),
  },
  methods: {
    ...mapActions('activities', ['setLastActivityUpdateCheck']),
    getActivityColor: getActivityColor,
    getActivityIcon: getActivityIcon,
    row_classes(item) {
      const momentLastActivityUpdateCheck = moment(this.previousLastUpdateCheck)
      const momentUpdatedAt = moment(item.updatedAt)
      if (momentUpdatedAt.isAfter(momentLastActivityUpdateCheck)) {
        return "yellow darken-3";
      }
    }
  }
}
